export default "__VITE_ASSET__cAYAh6HM__"